module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        用户预约了今天 "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.appointmentTime))]), _vm._v(" 时段，与 "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.organizationName))]), _vm._v(" 进行远程问询，用户预约信息如下：\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "detail_case"
  }, [_c('div', {
    staticClass: "detail_item"
  }, [_c('b', [_vm._v("驾驶证")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("姓名")]), _vm._v(" "), (_vm.detailInfo.driverCardInfo) ? _c('li', [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "size": "mini",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.detailInfo.driverCardInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo.driverCardInfo, "name", $$v)
      },
      expression: "detailInfo.driverCardInfo.name"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("性别")]), _vm._v(" "), (_vm.detailInfo.driverCardInfo) ? _c('li', [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "mini",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.detailInfo.driverCardInfo.sex),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo.driverCardInfo, "sex", $$v)
      },
      expression: "detailInfo.driverCardInfo.sex"
    }
  }, _vm._l((_vm.sexTypeLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xb"),
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("准驾车型")]), _vm._v(" "), (_vm.detailInfo.driverCardInfo) ? _c('li', [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "mini",
      "disabled": _vm.disabled_edit,
      "multiple": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.moreCarClass),
      callback: function($$v) {
        _vm.moreCarClass = $$v
      },
      expression: "moreCarClass"
    }
  }, _vm._l((_vm.tempList.driList), function(item) {
    return _c('el-option', {
      key: item.CODE,
      attrs: {
        "label": item.CODE,
        "value": ("" + (item.id))
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("驾驶证号")]), _vm._v(" "), (_vm.detailInfo.driverCardInfo) ? _c('li', [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "size": "mini",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.detailInfo.driverCardInfo.driverCardNo),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo.driverCardInfo, "driverCardNo", $$v)
      },
      expression: "detailInfo.driverCardInfo.driverCardNo"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("地址")]), _vm._v(" "), (_vm.detailInfo.driverCardInfo) ? _c('li', [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "rows": 3,
      "size": "mini",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.detailInfo.driverCardInfo.address),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo.driverCardInfo, "address", $$v)
      },
      expression: "detailInfo.driverCardInfo.address"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "detail_item"
  }, [_c('b', [_vm._v("身份证")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("姓名")]), _vm._v(" "), (_vm.detailInfo.idCardInfo) ? _c('li', [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "size": "mini",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.detailInfo.idCardInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo.idCardInfo, "name", $$v)
      },
      expression: "detailInfo.idCardInfo.name"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("性别")]), _vm._v(" "), (_vm.detailInfo.idCardInfo) ? _c('li', [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "mini",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.detailInfo.idCardInfo.sex),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo.idCardInfo, "sex", $$v)
      },
      expression: "detailInfo.idCardInfo.sex"
    }
  }, _vm._l((_vm.sexTypeLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xb2"),
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("民族")]), _vm._v(" "), (_vm.detailInfo.idCardInfo) ? _c('li', [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "size": "mini",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.detailInfo.idCardInfo.nation),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo.idCardInfo, "nation", $$v)
      },
      expression: "detailInfo.idCardInfo.nation"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("出生日期")]), _vm._v(" "), (_vm.detailInfo.idCardInfo) ? _c('li', [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "size": "mini",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.detailInfo.idCardInfo.birthday),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo.idCardInfo, "birthday", $$v)
      },
      expression: "detailInfo.idCardInfo.birthday"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("身份证号")]), _vm._v(" "), (_vm.detailInfo.idCardInfo) ? _c('li', [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "size": "mini",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.detailInfo.idCardInfo.idNum),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo.idCardInfo, "idNum", $$v)
      },
      expression: "detailInfo.idCardInfo.idNum"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "detail_item"
  }, [_c('b', [_vm._v("行驶证")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("姓名")]), _vm._v(" "), (_vm.detailInfo.vehicleCardInfo) ? _c('li', [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "size": "mini",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.detailInfo.vehicleCardInfo.owner),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo.vehicleCardInfo, "owner", $$v)
      },
      expression: "detailInfo.vehicleCardInfo.owner"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("车牌号码")]), _vm._v(" "), (_vm.detailInfo.vehicleCardInfo) ? _c('li', [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "size": "mini",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.detailInfo.vehicleCardInfo.plateNo),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo.vehicleCardInfo, "plateNo", $$v)
      },
      expression: "detailInfo.vehicleCardInfo.plateNo"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("车辆识别代码")]), _vm._v(" "), (_vm.detailInfo.vehicleCardInfo) ? _c('li', [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "size": "mini",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.detailInfo.vehicleCardInfo.vin),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo.vehicleCardInfo, "vin", $$v)
      },
      expression: "detailInfo.vehicleCardInfo.vin"
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "retrun_case"
  }, _vm._l((_vm.detailInfo.evidences), function(item, index) {
    return _c('span', {
      key: index
    }, [(item.url.indexOf('.mp4') == -1) ? _c('el-image', {
      staticClass: "retrun_image",
      attrs: {
        "fit": "contain",
        "lazy": "",
        "src": _vm.getImageUrl(item.url)
      },
      on: {
        "click": function($event) {
          return _vm.previewImg(item.url)
        }
      }
    }) : _c('img', {
      staticClass: "retrun_image",
      attrs: {
        "fit": "contain",
        "lazy": "",
        "src": require("../../../assets/images/pics/player.png")
      },
      on: {
        "click": function($event) {
          return _vm.previewImg(item.url)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("关闭")]), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onNext
    }
  }, [_vm._v("进入处理")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("取消预约")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAppointmentSuccess
    }
  }, [_vm._v("预约成功")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "取消预约原因",
      "center": "",
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      "placeholder": "请选择取消预约类型",
      "size": "mini"
    },
    on: {
      "change": _vm.onSelect
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  }, _vm._l((_vm.typeLists), function(item) {
    return _c('el-option', {
      key: ("" + (item.id)),
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请填写取消预约原因",
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-016a6935","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/weifa/components/detail.vue
// module id = OH+1
// module chunks = 6